// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FullscreenExitOutlinedSvg from "@fishx/icons-svg/es/asn/FullscreenExitOutlined";
import FishxIcon from '../components/FishxIcon';

var FullscreenExitOutlined = function FullscreenExitOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FullscreenExitOutlinedSvg
  }));
};

FullscreenExitOutlined.displayName = 'FullscreenExitOutlined';
export default React.forwardRef(FullscreenExitOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FullscreenExitOutlined.js
// module id = 2842
// module chunks = 0